import { Badge } from '@kula-ai/components';
import { StatusDot } from './StatusDot';

interface StatusPillProps {
  label: string;
  /** Dot colour — a theme token or a hex from a domain status config. */
  color?: string;
}

// Outline badge with a leading colour dot. One status pill for every block.
export const StatusPill = ({ label, color }: StatusPillProps) => (
  <Badge
    type="outline"
    color="white"
    leftElement={color ? <StatusDot color={color} size="6px" /> : undefined}
  >
    {label}
  </Badge>
);
